import { HttpClient, HttpParams } from '@angular/common/http';
import { inject, Injectable, OnDestroy } from '@angular/core';
import { map, Observable, Observer, of } from 'rxjs';
import { AppConfigService } from './app-config.service';


@Injectable({
  providedIn: 'root'
})
export class ProductCatalogService  implements OnDestroy {

 
  url = AppConfigService.settings.baseUrl;
constructor(private http:HttpClient) { }
  convertBlobToBase64(blob: Blob): Observable<string | null> {
  if (!blob || !(blob instanceof Blob)) {
    return of(null);
  }

  return new Observable<string | null>((observer) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      observer.next(reader.result as string);
      observer.complete();
    };

    reader.onerror = () => {
      observer.next(null);
      observer.complete();
    };

    reader.readAsDataURL(blob);
  });
}

getCatalogs():Observable<any>{

  return this.http.get<any>(`${AppConfigService.settings.apiUrl}catalog`);
}
getCatalogProducts(catalogId:number,catalogCode:string,page: number = 1, pageSize: number = 10):Observable<any>{
 const params = new HttpParams()
    .set('page', page.toString())
    .set('pageSize', pageSize.toString());
  return this.http.get<any>(`${AppConfigService.settings.apiUrl}Catalog/GetCatalogDetails/${catalogId}/${catalogCode}`
        ,{ params }
  )
}
addCatalog(data:any):Observable<any>{
return this.http.post<any>(`${AppConfigService.settings.apiUrl}catalog`,data);
}
updateCatalog(data:any,id:number):Observable<any>{
  return this.http.put<any>(`${AppConfigService.settings.apiUrl}catalog/${id}`,data);
}

updateCatalogMedia(type: number, catalogId: number, data: any): Observable<any> {

 // const url = `http://localhost:82/api/Media/UpdateCatalogMedia/${type}/${catalogId}`;
  const url = `${AppConfigService.settings.apiUrl}Media/UpdateCatalogMedia/${type}/${catalogId}`;
  return this.http.patch(url, data, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

deleteCatalog(id: number): Observable<any> {
  return this.http.delete<any>(`${AppConfigService.settings.apiUrl}catalog/${id}`);
}
getCatalogProductDetails(id: number, catalogCode: string, productId: number): Observable<any> {
  return this.http.get<any>(
    `${AppConfigService.settings.apiUrl}Catalog/GetCatalogProductDetails/${id}/${catalogCode}/${productId}`
  );
}

getMedia(attributeId?: number, objType?: number, objKey?: number, withBase64: boolean = false): Observable<any> {
  
  let params = new HttpParams();
  if (attributeId !== undefined) {
    params = params.append('attributeId', attributeId.toString());
  }
  if (objType !== undefined) {
    params = params.append('objType', objType.toString());
  }
  if (objKey !== undefined) {
    params = params.append('objKey', objKey.toString());
  }
  params = params.append('withBase64', withBase64.toString());
  
  return this.http.get<any>(`${AppConfigService.settings.apiUrl}Media`, { params });
}

applyCondition(conditionData:any):Observable<any>{
  return this.http.post<any>(`${AppConfigService.settings.apiUrl}CustomProduct/GetProductsByFilter`,conditionData);
}
// getAtribute(){
//   //&expand=AttributeValueAttributes 
//   return this.http.get(`${AppConfigService.settings.dataApiUrl}Attribute?expand=AttributeOptions`);
// }

processMediaData(mediaData: any[], thumbnailMediaObjectId: number | null, bannerMediaObjectId:number | null) {
  let thumbUrl: string | null = null;
  let bannerUrl: string | null = null;
 

  if (thumbnailMediaObjectId) {
    const thumbnailImage = mediaData.find(media => media.id === thumbnailMediaObjectId);
    if (thumbnailImage) {
      thumbUrl = thumbnailImage.fullPath || '';
      thumbUrl = thumbUrl ? this.url + 'api/Media/get-media?path=' + thumbUrl : null;
    }
  }
  if (bannerMediaObjectId) {
    const bannerImage = mediaData.find(media => media.id === bannerMediaObjectId);
    if (bannerImage) {
      bannerUrl = bannerImage.fullPath || '';
      bannerUrl = bannerUrl ? this.url + 'api/Media/get-media?path=' + bannerUrl : null;
    }
  }
  if (thumbUrl) {
    thumbUrl = thumbUrl.replace(/\\/g, '/');
  }
  if (bannerUrl) {
    bannerUrl = bannerUrl.replace(/\\/g, '/');
  }

  return { thumbUrl, bannerUrl };
}


getListPayload(objectId: number, objectType: number){
  const url = `${AppConfigService.settings.apiUrl}v2/list-payload/${objectId}/${objectType}`;
return this.http.get(url);
}


addListPayload(objectId: number, objectType: number, requestBody: any): Observable<any> {
  const url = `${AppConfigService.settings.apiUrl}v2/list-payload/${objectId}/${objectType}`;

  return this.http.post<any>(url, requestBody);
}
editListPayload(objectId: number, objectType: number, requestBody: any): Observable<any> {
  const url = `${AppConfigService.settings.apiUrl}v2/list-payload/${objectId}/${objectType}`;
  return this.http.put<any>(url, requestBody);
}
deleteListPayload(objectId: number, objectType: number): Observable<any> {
  const url = `${AppConfigService.settings.apiUrl}v2/list-payload/${objectId}/${objectType}`;
  return this.http.delete<any>(url);
}


getImage(options: { width?: number; height?: number; id?: number; catalogCode?: string }): Observable<Blob> {
  let params = new HttpParams();

  if (options.width !== undefined) {
    params = params.set('width', options.width.toString());
  }

  if (options.height !== undefined) {
    params = params.set('height', options.height.toString());
  }

  if (options.id !== undefined) {
    params = params.set('id', options.id);
  }

  if (options.catalogCode) {
    params = params.set('catalogCode', options.catalogCode);
  }

  return this.http.get(`${AppConfigService.settings.apiUrl}Catalog/get-media`, { params, responseType: 'blob'  });
}

getMediaProduct(options: 
  { width?: number; height?: number; attribute?: string; productId?: number }) : Observable<Blob> {
  let params = new HttpParams();

  if (options.width !== undefined) {
    params = params.set('width', options.width.toString());
  }

  if (options.height !== undefined) {
    params = params.set('height', options.height.toString());
  }

  if (options.attribute !== undefined) {
    params = params.set('attribute', options.attribute.toString());
  }

  if (options.productId !== undefined) {
    params = params.set('productId', options.productId.toString());
  }
  
 return this.http.get(`${AppConfigService.settings.apiUrl}Catalog/get-media`, {
    params,
    responseType: 'blob'
  });
}


    private objectUrls: Set<string> = new Set();
  createImageUrl(blob: Blob): string {
    const url = URL.createObjectURL(blob);
    this.objectUrls.add(url);
    return url;
  }
  revoke(url: string): void {
    if (this.objectUrls.has(url)) {
      URL.revokeObjectURL(url);
      this.objectUrls.delete(url);
    }
  }
    revokeAll(): void {
    this.objectUrls.forEach(url => URL.revokeObjectURL(url));
    this.objectUrls.clear();
  }
    ngOnDestroy(): void {
    this.revokeAll();
  }


getCurrencies(): Observable<any> {
  return this.http.get('/assets/data/currencies.json');
}


  // bullk

    selectAllCatalogProducts(IDCatalog: number): Observable<any> {
    const url = `${AppConfigService.settings.apiUrl}Catalog/${IDCatalog}/SelectAllCatalogProducts`;
    return this.http.get<any>(url);
    }

    bulkAddCatalogProducts(IDCatalog: number, productIds: number[]): Observable<any> {
    const url = `${AppConfigService.settings.apiUrl}Catalog/${IDCatalog}/BulkAddCatalogProducts`;
    return this.http.put<any>(url, productIds);
    }

    bulkDeleteCatalogProducts(key:number,ids:number[]) {
    return this.http.put(`${AppConfigService.settings.apiUrl}Catalog/${key}/BulkDeleteCatalogProducts`, ids);
    }
}
